import Image from "next/image";
import { TArticleType } from "./ArticlesArea";
import Link from "next/link";
import Skeleton from "../common/Skeleton";

const ArticleCard = ({
  article,
  loading,
}: {
  article?: TArticleType;
  loading?: boolean;
}) => {
  if (loading) {
    return (
      <div className="flex h-full w-full flex-col gap-6 rounded-[26px] border-[0.726px] border-[#E8E8E8] xlg:gap-4">
        <div className="flex flex-grow flex-col items-start xlg:flex-row">
          <div className="h-[360px] w-full overflow-hidden rounded-t-[26px] xlg:h-[260px] xlg:rounded-l-[26px] xlg:rounded-tr-none">
            <Skeleton className="h-[360px] bg-gray-300 xlg:h-[260px]" />
          </div>
          <div className="flex h-full w-full flex-col justify-between p-4 xlg:p-6">
            <Skeleton className="h-[20px] w-[100px] rounded bg-gray-300" />
            <Skeleton className="h-[80px] rounded bg-gray-300" />
            <div className="flex items-center justify-between">
              <Skeleton className="h-[20px] w-[80px] rounded bg-gray-300" />
              <Skeleton className="h-[20px] w-[60px] rounded bg-gray-300" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!article) return null;

  return (
    <div>
      <Link
        href={`https://kroolo.com${article.linkUrl}`}
        target="_blank"
        aria-label={`Read more about ${article.title}`}
        className="flex h-full w-full flex-col gap-6 rounded-[26px] border-[0.726px] border-[#E8E8E8] xlg:gap-4"
      >
        <div className="flex flex-grow flex-col items-start xlg:flex-row">
          {article.image && (
            <div className="w-full overflow-hidden rounded-t-[26px] xlg:h-[260px] xlg:rounded-l-[26px] xlg:rounded-tr-none">
              <Image
                src={article.image}
                alt={`${article.title || "Article"} thumbnail`}
                quality={100}
                width={600}
                height={400}
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </div>
          )}
          <div className="flex w-full flex-col justify-between p-4 max-[1199px]:gap-4 xlg:p-6 xl:h-full">
            <p className="text-[14px] font-normal text-[#717171]">
              {article.author || "Anonymous"}
            </p>
            <p className="text-[18px] font-semibold text-[#202020]">
              {article.title || "No Title Available"}
            </p>
            <div className="flex items-center justify-between">
              <p className="text-[14px] font-semibold text-[#202020]">
                {article.tag || "Uncategorized"}
              </p>
              <p className="text-[14px] font-normal text-[#202020]">
                {article.posted_at || "Unknown Date"}
              </p>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ArticleCard;
